import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	level3: {
		paddingBottom: theme.spacing(2)
	}
}));

export default styles;
